"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupRequest = exports.ChangeProductStatusRequest = exports.UpdateRiseupAccountRequest = exports.CreateRiseupAccountRequest = void 0;
const z = require("zod");
const RiseupAccount_1 = require("./RiseupAccount");
const Member_1 = require("./Member");
exports.CreateRiseupAccountRequest = RiseupAccount_1.RiseupAccount.deepPartial();
exports.UpdateRiseupAccountRequest = RiseupAccount_1.RiseupAccount.deepPartial();
exports.ChangeProductStatusRequest = z.array(RiseupAccount_1.RiseupProduct);
exports.SignupRequest = z.object({
    riseupProduct: RiseupAccount_1.RiseupProduct,
    riseupMarket: RiseupAccount_1.RiseupMarket,
    createMemberRequest: Member_1.CreateMemberRequest,
});
//# sourceMappingURL=RiseupAccountRequests.js.map